import { useLocation } from "react-router-dom";

export const useWorkspaceId = () => {
  const { pathname } = useLocation();
  const workspaceId = pathname.split("/workspace/")[1]?.split("/")[0];
  const projectId = pathname.split("/project/")[1]?.split("/")[0]

  return { workspaceId, projectId };
};
